import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCall } from "../../utils/api";

const initialState = {
  data: [],
  feedbackData: null,
  error: "",
  status: "idle",
};

export const getDashboard = createAsyncThunk("dashboard/get", async (_) => {
  try {
    const response = await getCall("/admin/v1/total_counts", false);
    return await response?.data;
  } catch (error) {
    return Promise?.reject(error);
  }
});

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDashboard.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getDashboard.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getDashboard.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      });
  },
});

export default dashboardSlice.reducer;
